import { FC, useMemo } from 'react';

import { useRecoilValue } from 'recoil';

import { useWorkerUserAgencyAdminHook } from '@shared/api/user/user.hook';
import { workerUserAgencyAdminStateSelector } from '@shared/api/user/user.selector';
import { CheckBoxFilter } from '@shared/components/CheckboxFilter';
import { Loading } from '@shared/components/Loading';
import { ReloadButton } from '@shared/components/ReloadButton';
import StatPageSideBar from '@shared/components/StatPageSideBar';
import { useAuth } from '@shared/state/hooks/useAuth';
import { LowerRole } from '@shared/types';
import { useParams } from 'react-router-dom';

import AgencyAdminRankTable from '../containers/AgencyAdminBugoListTable/AgencyAdminRankTable';
import { dateRangeAtom } from '../containers/AgencyAdminBugoListTable/table.atom';
import { useTitleHook } from '../hooks/useTitleHook';

const AgencyAdminWorkerStatPage: FC = () => {
  const { bugoBrandId } = useParams();
  const bugoBrandId_ = bugoBrandId ?? 'undefined';
  useTitleHook('관리자용 페이지', undefined, undefined, true, '/');

  const dateRange = useRecoilValue(dateRangeAtom);

  useWorkerUserAgencyAdminHook(bugoBrandId_, dateRange);

  const { userProfile, bugoRole } = useAuth();

  const teamTypesFilter = useMemo(() => {
    if (bugoRole() === LowerRole.BugoAgencyBranchAdmin) {
      return null;
    } else {
      const bugoBrand = userProfile?.bugoAgencyAdminDetail?.bugoBrands[0];
      const teamTypes = bugoBrand?.bugoAgency?.teamTypes ?? [];
      const result: CheckBoxFilter = {};
      teamTypes.forEach((teamType) => (result[teamType] = true));
      return result;
    }
  }, [bugoRole, userProfile?.bugoAgencyAdminDetail?.bugoBrands]);

  const workerUserState = useRecoilValue(
    workerUserAgencyAdminStateSelector(bugoBrandId_),
  );

  const table = useMemo(() => {
    if (workerUserState.status === 'success' && workerUserState.data) {
      return (
        <AgencyAdminRankTable
          workerUserList={workerUserState.data}
          teamTypesFilter={teamTypesFilter}
        />
      );
    } else {
      return (
        <div className="center-box h-screen-15">
          <Loading />
        </div>
      );
    }
  }, [workerUserState.status, workerUserState.data, teamTypesFilter]);

  return (
    <div className="flex">
      {/* Sidebar */}
      <div className="flex flex-col">
        <StatPageSideBar />
      </div>
      <div className="mx-auto max-w-screen-2xl flex-1">
        <div className="py-8 px-10">
          <div className="flex justify-between space-x-10">
            <div>
              <p className="text-20 font-bold">지도사 내역 조회</p>
              <p className="font-sm pt-2 text-gray-500">
                조건을 설정하여 조회할 수 있습니다.(최대 15개월 이내의 데이터 조회 가능)
              </p>
            </div>
            <div className="center-box h-full gap-4">
              <ReloadButton />
            </div>
          </div>
          <div className="pt-4">{table}</div>
        </div>
      </div>
    </div>
  );
};

export default AgencyAdminWorkerStatPage;
